
/** stuff on the IPA charts that consists of a single symbol */
export const ipaSingles = [
  // plosive
  'p', 'b', 't', 'd', 'ʈ', 'ɖ', 'ȶ', 'c', 'ɟ', 'k', 'ɡ', 'q', 'ɢ', 'ʔ', 'ʡ',
  // nasal
  'm', 'ɱ', 'n', 'ɳ', 'ȵ', 'ɲ', 'ŋ', 'ɴ',
  // trill
  'ʙ', 'r', 'ʀ', 'ʜ', 'ʢ',
  // tap or flap
  'ⱱ', 'ɾ', 'ɽ',
  // fricative
  'ɸ', 'β', 'f', 'v', 'θ', 'ð', 'ʍ', 's', 'z', 'ʃ', 'ʒ', 'ʂ', 'ʐ', 'ʆ', 'ʓ', 'ç', 'ʝ', 'ɕ', 'ʑ', 'x', 'ɣ', 'χ', 'ʁ', 'ħ', 'ʕ', 'h', 'ɦ',
  // lateral fricative
  'ɬ', 'ɮ',
  // approximant
  'ʋ', 'w', 'ɹ', 'ɻ', 'j', 'ɰ',
  // lateral approximant
  'l', 'ɭ', 'ȴ', 'ʎ', 'ʟ',
  // click
  'ʘ', 'ǀ', 'ǃ', 'ǂ', 'ǁ',
  // voiced implosive
  'ɓ', 'ɗ', 'ᶑ', 'ʄ', 'ɠ', 'ʛ',
  // vowel
  'i', 'y', 'ɨ', 'ʉ', 'ɯ', 'u', 'ɪ', 'ʏ', 'ʊ', 'e', 'ø', 'ɘ', 'ɵ', 'ɤ', 'o', 'ə', 'ɛ', 'œ', 'ɜ', 'ɞ', 'ʌ', 'ɔ', 'æ', 'ɐ', 'a', 'ɶ', 'ɑ', 'ɒ',
  // tones
  '˥', '˦', '˧', '˨', '˩',
];

/** stuff on the IPA charts that consists of 2 or more symbols */
export const ipaCombos = [
  // dentals
  'p̪', 'b̪', 't̪', 'd̪', 'n̪', 'r̪', 'ɾ̪', 'l̪', 'ɬ̪', 'ɮ̪',
  // labial velars
  'kp', 'ɡb', 'ŋm', 'ɠ̊ɓ̥', 'ɠɓ',
  // postaveolar
  't̠', 'd̠', 'n̠', 'r̠',
  // taps
  'ⱱ̟', 'ɾ̥', 'ɽ̊',
  // affricates
  'pɸ', 'bβ', 'pf', 'bv', 't̪θ', 'd̪ð',
  'ts', 'dz', 't̠ʃ', 'd̠ʒ', 'ʈʂ', 'ɖʐ', 'tɕ', 'dʑ',
  'cç', 'ɟʝ', 'kx', 'qχ', 'ɢʁ',
  // approximant
  'β̞', 'ð̞', 'ʁ̞',
  // voiceless nasals
  'm̥', 'ɱ̥', 'n̥', 'ɳ̥', 'ɲ̥', 'ŋ̥',
  // voiceless trills
  'r̥', 'ʀ̥',
  // voiceless lateral approximates
  'l̥',
  // voiceless implosives
  'ɓ̥', 'ɗ̥', 'ʄ̥', 'ɠ̥', 'ʛ̥',
  // ejectives
  'pʼ', 't̪ʼ', 'tʼ', 'ʈʼ', 'cʼ', 'kʼ', 'qʼ', 'ʔʼ',
  'ɸʼ', 'fʼ', 'wʼ', 'θʼ', 'ðʼ', 'sʼ', 'zʼ', 'ʃʼ', 'ʒʼ', 'ʂʼ', 'ɕʼ', 'çʼ', 'xʼ', 'χʼ', 'ʕʼ', 'hʼ',
  // mid (lowered) vowels
  'e̞', 'ø̞', 'ɤ̞', 'o̞',
  // these are the most common combined sets of tone bars
  '˦˨', '˨˦', '˥˩', '˩˥', '˨˧', '˧˨', '˥˦', '˧˩', '˦˧', '˩˨', '˦˥', '˧˥', '˧˦', '˨˦˨', '˦˨˦'
];

/** common or interesting vowel segments not otherwise on a chart */
export const miscVowels =
  ['iː', 'aː', 'uː', 'eː', 'oː', 'ĩ', 'ã', 'ũ', 'õ', 'ɛ̃', 'ai', 'au', 'ia', 'ui', 'ua', 'm̩', 'n̩', 'ŋ̩', 'l̩', 'ə˞', 'a˞', 'ɚ'];
/** common or interesting consonant segments not otherwise on a chart */
export const miscConsonants =
  ['kʰ', 'pʰ', 'tʰ', 'kʷ', 't̠ʃʰ', 't̠ʃʼ', 'kʲ', 'mb', 'nd', 'ŋɡ', 'n̠d̠ʒ', 'n̺', 'r̺', 'l̺', 'nː', 'kː', 'lː', 'sː', 'pː', 'ɥ', 'ɺ', 'ɫ', 'tɬ', 'dɮ', 'ᴅ', 'r̝', 'ɧ'];
/** common or interesting click segments not otherwise on a chart */
export const miscClicks =
  ['kʘ', 'kǀ', 'kǃ', 'k‼', 'kǂ', 'kǁ', 'ɡʘ', 'ɡǀ', 'ɡǃ', 'ɡ‼', 'ɡǂ', 'ɡǁ', 'ŋʘ', 'ŋǀ', 'ŋǃ', 'ŋ‼', 'ŋǂ', 'ŋǁ', 'kǃʰ', 'kǀʰ', 'kǁʰ', 'kǀʼ', 'kǁʼ', 'kǃʼ'];
